export class WebhookV1StandardPayloadSnapshotArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotArguments",
            "baseName": "snapshotArguments",
            "type": "WebhookV1SnapshotArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadSnapshotArguments.attributeTypeMap;
    }
    constructor() {
    }
}
